import { get, post, getToken as _getToken, postFormData } from './fetch';

export const buyerRegistration = (data) => {
    return post(`/api/buyer/register`, data, false);
}

export const saveServiceRequest = (data) => {
    return postFormData(`/api/buyer/request/photos`, data, true);
}

export const getBuyerRequests = () => {
    return get(`/api/buyer/requests`, true);
}

export const getExpiredBuyerRequests = () => {
    return get(`/api/buyer/requests/expired`, true);
}

export const getAcceptedNonServicedBuyerRequests = () => {
    return get(`/api/buyer/requests/accepted/non-serviced`, true);
}

export const getBuyerRequestBids = (singleBuyerRequestID) => {
    return get(`/api/buyer/request/${singleBuyerRequestID}/bids`, true);
}

export const acceptBid = (data) => {
    return post(`/api/buyer/acceptbid`, data, true);
}

export const validatePromoCode = (data) => {
    return post(`/api/promo/validate`, data, false);
}

export const buyerProfileUpdate = (data) => {
    return post(`/api/buyer/profile/update`, data, true);
}

